/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import events from "dom/events";

const PRE_FEED_CONTENT_HIDDEN_MODIFIER = "product-feed-layout__pre-feed-content--hidden";

export default baustein.register("pre-feed-content", {
    /**
     * Does what it says. So much pop.
     *
     * @returns {Promise}
     */
    fadeOut() {
        const initialHeight = parseInt(getComputedStyle(this.el).getPropertyValue("height"), 10);

        return events
            .onTransitionEnd(this.el, el => {
                el.classList.add(PRE_FEED_CONTENT_HIDDEN_MODIFIER);
            })
            .then(() => {
                return initialHeight;
            });
    }
});

